import React from "react";

import { Play, Radio, TrendingUp, TvMinimalPlay } from "lucide-react";
import { useTranslation } from "react-i18next";

import { cn } from "@/src/lib/utils";

import loginIllustration from "../../resources/login_illustration.png";

import type { LucideIcon } from "lucide-react";
import type { JSX } from "react";

const PILLAR_LIST: { key: string; Icon: LucideIcon }[] = [
  { key: "xvod", Icon: Play },
  { key: "live", Icon: Radio },
  { key: "fast", Icon: TvMinimalPlay },
  { key: "monetize", Icon: TrendingUp },
];

interface LoginBrandPanelProps {
  className?: string;
}

function LoginBrandPanel({ className }: LoginBrandPanelProps): JSX.Element {
  const { t } = useTranslation("login");

  return (
    <section
      className={cn(
        "@container/brand relative flex flex-1 flex-col justify-center overflow-hidden bg-[#010715] py-16 pr-12 pl-20 text-white",
        className,
      )}
    >
      <img
        aria-hidden
        alt=""
        className="absolute inset-0 size-full object-cover object-[65%_center]"
        src={loginIllustration}
      />
      <div className="relative flex flex-col items-start gap-6">
        <h2 className="text-[clamp(1.75rem,3.4cqi,3.25rem)] leading-[1.15] font-light">
          <span className="block">{t("brand.headline1")}</span>
          <span className="block">{t("brand.headline2")}</span>
          <span className="text-primary block">{t("brand.headline3")}</span>
        </h2>
        <span className="bg-primary h-0.5 w-16" />
        <p className="max-w-md text-base leading-relaxed text-white/70">
          {t("brand.subtitle")}
        </p>
        <ul className="mt-6 flex flex-nowrap items-stretch">
          {PILLAR_LIST.map(({ key, Icon }) => (
            <li
              key={key}
              className="flex shrink-0 flex-col items-center gap-[clamp(0.5rem,0.8cqi,0.75rem)] border-l border-white/15 px-[clamp(0.75rem,2.2cqi,2.25rem)] first:border-l-0 first:pl-0"
            >
              <Icon
                className="text-primary size-[clamp(2rem,3.5cqi,3rem)]"
                strokeWidth={1.5}
              />
              <span className="text-primary text-[clamp(0.75rem,1.15cqi,0.875rem)] font-medium tracking-widest whitespace-nowrap">
                {t(`brand.pillars.${key}`)}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default LoginBrandPanel;
